import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxWeekdayPickerModule } from 'ngx-weekday-picker';
import { ComponentsModule } from 'src/app/components/components.module';

import { KitDetailPageRoutingModule } from './kit-detail-routing.module';
import { KitDetailPage } from './kit-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    NgxWeekdayPickerModule,
    KitDetailPageRoutingModule,
    ComponentsModule
  ],
  declarations: [KitDetailPage]
})
export class KitDetailPageModule {}
